import mixins from 'vue-typed-mixins';

import RoutesMixin from '@/entries/user/mixins/RoutesMixin';
import 分析PlbscfMixin from '@/entries/user/mixins/分析PlbscfMixin';

import { PlbscfType } from '@/master/Plbscf';

export default mixins(RoutesMixin, 分析PlbscfMixin).extend({
  name: 'P現状変動損益',

  data(): {
    tabTypes: PlbscfType[];
  } {
    return {
      tabTypes: [PlbscfType.変動損益, PlbscfType.運転資金, PlbscfType.FCF],
    };
  },

  methods: {
    reload(): void {
      if (!confirm('更新しますか？')) return;
      this.load();
    },
    onChangeフリーキャッシュフロー種別(): void {
      // 再計算
      this.plbscfTypeLists = this.service.calcAndCreatePlbscfTypeList();
      this.initializeFlag();
    },
  },
});
